module.exports = __webpack_public_path__ + "static/media/preview_image_DELETE5.e4c6a4e4.png";